import { http } from '../../../../api/http';
import type { TomaInventario, TomaInventarioDetalle } from '../types/toma.types';

export const tomaInventarioService = {
  async getAll(): Promise<TomaInventario[]> {
    const response = await http.get('/inventario/toma');
    return response.data;
  },

  async getById(id: number): Promise<TomaInventario> {
    const response = await http.get(`/inventario/toma/${id}`);
    return response.data;
  },

  async create(toma: Partial<TomaInventario>): Promise<TomaInventario> {
    const response = await http.post('/inventario/toma', toma);
    return response.data;
  },

  async updateDetalles(idToma: number, detalles: TomaInventarioDetalle[]): Promise<void> {
    await http.put(`/inventario/toma/${idToma}/detalle`, detalles);
  },

  async generarAjuste(idToma: number): Promise<number> {
    const response = await http.post(`/inventario/toma/${idToma}/ajustar`);
    return response.data;
  },
};
